import { IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

import { getOfferTitle } from '../../../../utils/offer_helpers';
import { getRightDeclensionForOfferType } from './get_right_declension';

export function getTitle(offer: IOfferSchema) {
  const geoAddress = offer.geo.address.map(addressItem => addressItem.shortName).join(', ');
  const dealType =
    offer.dealType === 'sale'
      ? 'Купить'
      : offer.category && offer.category.includes('daily')
      ? 'Снять посуточно'
      : 'Снять';
  const offerTitle = getOfferTitle(offer);

  return `${dealType} ${getRightDeclensionForOfferType(offerTitle)} ${geoAddress}`;
}
